$(document).on('submit', '.js-dynamic-field-section-override-form', function (event) {
    event.preventDefault();

    var form = $(event.currentTarget);
    var action = form.attr('action');

    var showNotification = function (type, message) {
        if (!message) {
            return;
        }

        var title = type === 'warning' ? 'Warning!' : (type === 'error' ? 'Error!' : 'Success!');

        if (window.Vue && typeof window.Vue.notify === 'function') {
            window.Vue.notify({
                type: type,
                title: title,
                text: message,
            });
            return;
        }

        if (window.app && typeof window.app.$notify === 'function') {
            window.app.$notify({
                type: type,
                title: title,
                text: message,
            });
        }
    };

    window.axios.post(action)
        .then(function (response) {
            if (response && response.data && response.data.message && (!response.data.redirect)) {
                showNotification(response.data.notify_type ? response.data.notify_type : 'success', response.data.message);
            }

            if (response && response.data && response.data.redirect) {
                window.location.href = response.data.redirect;
            }
        })
        .catch(function (error) {
            var message = error && error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : 'An error has occured.';

            showNotification('error', message);
        });
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/dynamic-field-sections/Listing.js